/* eslint-disable @typescript-eslint/naming-convention */
import CustomDropdown from '@brands/Components/Inputs/CustomDropdown/CustomDropdown';
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import PhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import { pharmacyValidationSchema } from '@brands/Dashboard/MyProfile/Patient/utils/validationSchema';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { ICase } from '@brands/services/cases/types/ICase';
import { listClinicalData } from '@brands/services/clinical_data/listClinicalData';
import { MedicalHistory } from '@brands/services/clinical_data/types/types';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { addOneReportObject } from '@brands/services/oneReport/addOneReportObject';
import { ObjectType, updateOneReportObject } from '@brands/services/oneReport/updateOneReportObject';
import { selectAuth } from '@brands/store/selectors/auth';
import { consultationPharmacySectionSelectStyles } from '@brands/Utils/customStyles';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { checkCollapsibleHeaderColor } from '@brands/Utils/getCollapsibleHeader';
import { Option, stateOptions } from '@brands/Utils/selectOptions';
import { yupResolver } from '@hookform/resolvers/yup';
import { E164Number } from 'libphonenumber-js';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FieldErrors, useForm, UseFormRegister } from 'react-hook-form';

import { OralHealthReportSubmit, PharmacySubmit } from '../../assets/types';
import styles from '../../styles.module.scss';
import { PrescriptionForm } from '../PrescriptionSection/modal/PrescriptionModal';

type PharmacySectionProps = {
  consultationForm: OralHealthReportSubmit;
  setConsultationForm: React.Dispatch<React.SetStateAction<OralHealthReportSubmit>>;
  thisCase: ICase;
  setCase: React.Dispatch<React.SetStateAction<ICase>>;
  register: UseFormRegister<PrescriptionForm>;
  errors: any;
  setValue: any;
  watch: any;
};

const PharmacySection = ({
  consultationForm,
  setConsultationForm,
  thisCase,
  setCase,
  register,
  errors,
  setValue,
  watch,
}: PharmacySectionProps): JSX.Element => {
  const { userInfo } = useAppSelector(selectAuth);
  const containerRef = useRef<HTMLDivElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const [medicalHistory, setMedicalHistory] = useState<MedicalHistory | null>(null);
  const getFormAnswers = useCallback(async (createdByPatientId: number | undefined) => {
    const { medical_history } = await listClinicalData(createdByPatientId as number);

    setMedicalHistory(medical_history);
  }, []);

  useEffect(() => {
    (async () => {
      if (thisCase?.medical_history_snapshot) {
        const medical_history = thisCase?.medical_history_snapshot;

        setMedicalHistory(medical_history);
      } else {
        await getFormAnswers(Number(thisCase.patient_id));
      }
    })();
  }, []);

  const updatePharmacy = async (id: string, nonEmptyPayload: PharmacySubmit): Promise<void> => {
    try {
      const res = await updateOneReportObject(thisCase?.one_report.id || '', ObjectType.Pharmacy, {
        ...nonEmptyPayload,
        id,
      });
      setConsultationForm({
        ...consultationForm,
        pharmacies: res.pharmacies,
      });
      setCase({
        ...thisCase,
        one_report: {
          ...thisCase.one_report,
          pharmacies: res.pharmacies,
        },
      });
    } catch (error) {
      displayErrorDetails(error);
    }
  };

  /*   useEffect(() => {
    if (
      medicalHistory &&
      userInfo.role.name === UserRoleName.Provider &&
      userInfo.id === Number(thisCase.provider?.id && medicalHistory)
    ) {
      if (Object.keys(medicalHistory).length > 0) {
        Object.keys(medicalHistory).forEach((key) => {
          setValue(key as keyof PharmacySubmit, medicalHistory[key as keyof PharmacySubmit] as string, {
            shouldValidate: true,
          });
        });
        setConsultationForm({
          ...consultationForm,
          pharmacies: getValues(),
        });
        updatePharmacy(thisCase.one_report.pharmacies.id || '1', getValues());
      } else {
        setConsultationForm({
          ...consultationForm,
          pharmacies: thisCase.one_report.pharmacies,
        });
      }
    }
  }, [
    consultationForm,
    getValues,
    medicalHistory,
    setConsultationForm,
    setValue,
    thisCase.one_report.pharmacies,
    thisCase.provider?.id,
    updatePharmacy,
    userInfo.id,
    userInfo.role.name,
  ]); */
  const addPharmacy = async (nonEmptyPayload: PharmacySubmit): Promise<void> => {
    try {
      const res = await addOneReportObject(thisCase?.one_report.id || '', ObjectType.Pharmacy, {
        ...nonEmptyPayload,
      });
      setConsultationForm({
        ...consultationForm,
        pharmacies: res.pharmacies,
      });
      setCase({
        ...thisCase,
        one_report: {
          ...thisCase.one_report,
          pharmacies: res.pharmacies,
        },
      });
    } catch (error) {
      displayErrorDetails(error);
    }
  };

  const handlePharmacyOnBlur = async (pharmacy: PharmacySubmit): Promise<void> => {
    /*     const { id } = pharmacy;
    const nonEmptyPayload = {
      ...(pharmacy.pharmacy_name ? { pharmacy_name: pharmacy.pharmacy_name } : { pharmacy_name: '' }),
      ...(pharmacy.pharmacy_street_address
        ? { pharmacy_street_address: pharmacy.pharmacy_street_address }
        : { pharmacy_street_address: '' }),
      ...(pharmacy.pharmacy_city ? { pharmacy_city: pharmacy.pharmacy_city } : { pharmacy_city: '' }),
      ...(pharmacy.pharmacy_state ? { pharmacy_state: pharmacy.pharmacy_state } : { pharmacy_state: '' }),
      ...(pharmacy.pharmacy_zip_code ? { pharmacy_zip_code: pharmacy.pharmacy_zip_code } : { pharmacy_zip_code: '' }),
      ...(pharmacy.pharmacy_phone_number
        ? { pharmacy_phone_number: pharmacy.pharmacy_phone_number }
        : { pharmacy_phone_number: '' }),
    };

    if (id !== undefined) {
      await updatePharmacy(id, nonEmptyPayload);
    } else {
      await addPharmacy(nonEmptyPayload);
    } */
  };

  return (
    <div className={styles.descriptionInputs}>
      <div className={styles.selectInput}>
        <TextField
          {...register(`pharmacy_name`)}
          wrapperStyle={{
            marginTop: '0',
            borderBottom: 'none',
            minHeight: '30px',
            height: 'auto',
          }}
          name="pharmacy_name"
          label="Pharmacy Name"
          required
          errors={errors.pharmacy_name ? errors : {}}
          inputClass={`${styles.profileInputClass} fs-exclude`}
          wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
          placeholder=""
          onChange={(e) => {
            setValue('pharmacy_name', e.target.value, { shouldValidate: true, shouldDirty: true });
            setConsultationForm({
              ...consultationForm,
              pharmacies: {
                ...consultationForm?.pharmacies,
                pharmacy_name: e.target.value,
              },
            });
          }}
          onBlur={(e: any) => {
            handlePharmacyOnBlur({
              ...consultationForm.pharmacies,
              pharmacy_name: e.target.value,
            });
          }}
          disabled={checkCollapsibleHeaderColor(thisCase || '', userInfo, '') !== 'edit'}
        />
      </div>
      <div className={styles.selectInput}>
        <TextField
          {...register('pharmacy_street_address')}
          wrapperStyle={{
            borderBottom: 'none',
          }}
          label="Street Address"
          required
          name="pharmacy_street_address"
          errors={errors.pharmacy_street_address ? errors : {}}
          onChange={(e) => {
            setValue('pharmacy_street_address', e.target.value, { shouldValidate: true, shouldDirty: true });
            setConsultationForm({
              ...consultationForm,
              pharmacies: {
                ...consultationForm?.pharmacies,
                pharmacy_street_address: e.target.value,
              },
            });
          }}
          onBlur={(e: any) =>
            handlePharmacyOnBlur({
              ...consultationForm.pharmacies,
              pharmacy_street_address: e.target.value,
            })
          }
          wrapperClassName={`fs-exclude ${styles.inputWrapper}`}
          inputClass={styles.input}
          disabled={checkCollapsibleHeaderColor(thisCase || '', userInfo, '') !== 'edit'}
        />
      </div>
      <div className={`${styles.selectInput}`}>
        <div className={styles.input}>
          <TextField
            {...register(`pharmacy_city`)}
            wrapperStyle={{
              marginTop: '0',
              borderBottom: 'none',
              minHeight: '30px',
              height: 'auto',
            }}
            name="pharmacy_city"
            label="City"
            required
            errors={errors.pharmacy_city ? errors : {}}
            inputClass={`${styles.profileInputClass} fs-exclude`}
            wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
            placeholder=""
            onChange={(e) => {
              setValue('pharmacy_city', e.target.value, { shouldValidate: true, shouldDirty: true });
              setConsultationForm({
                ...consultationForm,
                pharmacies: {
                  ...consultationForm?.pharmacies,
                  pharmacy_city: e.target.value,
                },
              });
            }}
            onBlur={(e: any) =>
              handlePharmacyOnBlur({
                ...consultationForm.pharmacies,
                pharmacy_city: e.target.value,
              })
            }
            disabled={checkCollapsibleHeaderColor(thisCase || '', userInfo, '') !== 'edit'}
          />
        </div>
      </div>
      <div className={styles.descriptionInputsFirstGroup}>
        <div className={`${styles.selectInput}`}>
          <div className={styles.input}>
            <MUISelectInput
              {...register('pharmacy_state')}
              label="State"
              data-testid="pharmacy_state"
              errors={errors.pharmacy_state ? errors : {}}
              value={watch('pharmacy_state')}
              name="pharmacy_state"
              onChange={(e: any) => {
                setValue('pharmacy_state', e, { shouldDirty: true });
                setConsultationForm((prev) => ({
                  ...prev,
                  pharmacies: {
                    ...prev.pharmacies,
                    pharmacy_state: e,
                  },
                }));
              }}
              required
              inputClass={`${styles.profileInputClass} `}
              wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
              options={stateOptions}
            />
          </div>
        </div>
        <div className={`${styles.selectInput}`}>
          <div className={styles.input}>
            <TextField
              {...register(`pharmacy_zip_code`)}
              wrapperStyle={{
                marginTop: '0',
                borderBottom: 'none',
              }}
              label="Zip Code"
              required
              errors={errors.pharmacy_zip_code ? errors : {}}
              name="pharmacy_zip_code"
              inputClass={`${styles.profileInputClass} fs-exclude`}
              wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
              placeholder=""
              onChange={(e) => {
                setValue('pharmacy_zip_code', e.target.value, { shouldValidate: true, shouldDirty: true });
                setConsultationForm({
                  ...consultationForm,
                  pharmacies: {
                    ...consultationForm?.pharmacies,
                    pharmacy_zip_code: e.target.value,
                  },
                });
              }}
              onBlur={(e: any) =>
                handlePharmacyOnBlur({
                  ...consultationForm.pharmacies,
                  pharmacy_zip_code: e.target.value,
                })
              }
              disabled={checkCollapsibleHeaderColor(thisCase || '', userInfo, '') !== 'edit'}
            />
          </div>
        </div>
      </div>
      <div className={styles.selectInput}>
        <PhoneInput
          {...register('pharmacy_phone_number')}
          data-testid="complete-profile-phone_number"
          value={(watch('pharmacy_phone_number') as E164Number) ?? ''}
          id="pharmacy_phone_number"
          name="pharmacy_phone_number"
          onChange={(val) => {
            const updatedValue = val ?? '';
            setValue('pharmacy_phone_number', updatedValue, {
              shouldValidate: true,
              shouldDirty: true,
            });
            setConsultationForm((prev) => ({
              ...prev,
              pharmacies: {
                ...prev?.pharmacies,
                pharmacy_phone_number: val as string,
              },
            }));
          }}
          onBlur={() =>
            handlePharmacyOnBlur({
              ...consultationForm.pharmacies,
              pharmacy_phone_number: consultationForm.pharmacies.pharmacy_phone_number,
            })
          }
          required
          errors={errors}
          label="Phone number"
          inputClass={`${styles.profileInputClass} fs-exclude`}
          wrapperClassName={`fs-unmask ${styles.completeProfilePhone}`}
          ref={phoneInputRef}
        />
      </div>
    </div>
  );
};

export default PharmacySection;
